(() => {
  "use strict";
  function initialize(root) {
    if (root.dataset.artistReady) return;
    const cards = [...root.querySelectorAll("[data-artist-name]")];
    const search = root.querySelector("[data-artist-search]");
    if (!search || !cards.length) return;
    root.dataset.artistReady = "true";
    const tools = root.querySelector("[data-artist-tools]");
    const pages = root.querySelector("[data-artist-pages]");
    const count = root.querySelector("[data-artist-count]");
    const pageLabel = root.querySelector("[data-artist-page]");
    const previous = root.querySelector("[data-artist-prev]");
    const next = root.querySelector("[data-artist-next]");
    const empty = root.querySelector("[data-artist-empty]");
    const normalize = (value) =>
      value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    let page = 0;
    const size = 24;
    function draw() {
      const query = normalize(search.value);
      const matches = cards.filter((card) =>
        normalize(card.dataset.artistName).includes(query),
      );
      const pageCount = Math.max(1, Math.ceil(matches.length / size));
      page = Math.min(page, pageCount - 1);
      const visible = new Set(matches.slice(page * size, (page + 1) * size));
      for (const card of cards) card.hidden = !visible.has(card);
      count.textContent = `${matches.length} ${matches.length === 1 ? "artist" : "artists"}`;
      pageLabel.textContent = `${page + 1} / ${pageCount}`;
      previous.disabled = page === 0;
      next.disabled = page >= pageCount - 1;
      empty.hidden = matches.length > 0;
      pages.hidden = pageCount < 2;
    }
    search.addEventListener("input", () => {
      page = 0;
      draw();
    });
    previous.addEventListener("click", () => {
      page--;
      draw();
      tools.scrollIntoView({ block: "start" });
    });
    next.addEventListener("click", () => {
      page++;
      draw();
      tools.scrollIntoView({ block: "start" });
    });
    tools.hidden = false;
    draw();
  }
  document.querySelectorAll("[data-artist-directory]").forEach(initialize);
  document.addEventListener("shopify:section:load", (event) =>
    event.target
      .querySelectorAll("[data-artist-directory]")
      .forEach(initialize),
  );
})();
